/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Branding
 * OpenAPI спецификация для управления брендингом системы. Самодостаточный файл для генерации и документации. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Branding
 */
export interface Branding {
    /**
     * Уникальный идентификатор
     * @type {number}
     * @memberof Branding
     */
    'id'?: number;
    /**
     * Название компании
     * @type {string}
     * @memberof Branding
     */
    'companyName': string;
    /**
     * URL логотипа компании
     * @type {string}
     * @memberof Branding
     */
    'logoUrl'?: string;
    /**
     * Основной цвет брендинга
     * @type {string}
     * @memberof Branding
     */
    'primaryColor': string;
    /**
     * Дополнительный цвет брендинга
     * @type {string}
     * @memberof Branding
     */
    'secondaryColor'?: string;
    /**
     * Приветственное сообщение
     * @type {string}
     * @memberof Branding
     */
    'welcomeMessage'?: string;
    /**
     * Подпись для email-сообщений
     * @type {string}
     * @memberof Branding
     */
    'emailSignature'?: string;
    /**
     * Бенефиты компании (автозаполняется в соц.пакет новых вакансий)
     * @type {string}
     * @memberof Branding
     */
    'benefits'?: string;
    /**
     * Дата создания
     * @type {string}
     * @memberof Branding
     */
    'createdAt'?: string;
    /**
     * Дата последнего обновления
     * @type {string}
     * @memberof Branding
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface BrandingUpdateRequest
 */
export interface BrandingUpdateRequest {
    /**
     * Название компании
     * @type {string}
     * @memberof BrandingUpdateRequest
     */
    'companyName': string;
    /**
     * URL логотипа компании
     * @type {string}
     * @memberof BrandingUpdateRequest
     */
    'logoUrl'?: string;
    /**
     * Основной цвет брендинга
     * @type {string}
     * @memberof BrandingUpdateRequest
     */
    'primaryColor': string;
    /**
     * Дополнительный цвет брендинга
     * @type {string}
     * @memberof BrandingUpdateRequest
     */
    'secondaryColor'?: string;
    /**
     * Приветственное сообщение
     * @type {string}
     * @memberof BrandingUpdateRequest
     */
    'welcomeMessage'?: string;
    /**
     * Подпись для email-сообщений
     * @type {string}
     * @memberof BrandingUpdateRequest
     */
    'emailSignature'?: string;
    /**
     * Бенефиты компании (автозаполняется в соц.пакет новых вакансий)
     * @type {string}
     * @memberof BrandingUpdateRequest
     */
    'benefits'?: string;
}
/**
 * Стандартный ответ об ошибке
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * Список ошибок валидации
     * @type {Array<string>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetMyCompanyBranding401Response
 */
export interface GetMyCompanyBranding401Response {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof GetMyCompanyBranding401Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMyCompanyBrandingRequest
 */
export interface UpdateMyCompanyBrandingRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMyCompanyBrandingRequest
     */
    'companyName'?: string;
    /**
     * Файл логотипа (PNG, JPG, JPEG, SVG)
     * @type {File}
     * @memberof UpdateMyCompanyBrandingRequest
     */
    'logoFile'?: File;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyCompanyBrandingRequest
     */
    'primaryColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyCompanyBrandingRequest
     */
    'secondaryColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyCompanyBrandingRequest
     */
    'welcomeMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMyCompanyBrandingRequest
     */
    'emailSignature'?: string;
}

/**
 * BrandingApi - axios parameter creator
 * @export
 */
export const BrandingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Удаляет текущий логотип компании пользователя. Операция идемпотентна. После удаления система использует дефолтный логотип. 
         * @summary Удалить логотип компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyCompanyLogo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/companies/my/branding/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить настройки брендинга
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranding: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/branding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает брендинг компании пользователя. Если у компании нет собственного брендинга, возвращается fallback брендинг компании ID=1. 
         * @summary Получить брендинг своей компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCompanyBranding: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/companies/my/branding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить настройки брендинга
         * @param {BrandingUpdateRequest} brandingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBranding: async (brandingUpdateRequest: BrandingUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandingUpdateRequest' is not null or undefined
            assertParamExists('updateBranding', 'brandingUpdateRequest', brandingUpdateRequest)
            const localVarPath = `/branding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandingUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет или создает брендинг для компании пользователя. Если брендинг не существует, создается новый. 
         * @summary Обновить брендинг своей компании
         * @param {BrandingUpdateRequest} brandingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyCompanyBranding: async (brandingUpdateRequest: BrandingUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandingUpdateRequest' is not null or undefined
            assertParamExists('updateMyCompanyBranding', 'brandingUpdateRequest', brandingUpdateRequest)
            const localVarPath = `/companies/my/branding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandingUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Загружает новый логотип для компании пользователя. Старый логотип удаляется с диска после успешного сохранения нового. 
         * @summary Загрузить логотип компании
         * @param {File} logoFile Файл логотипа (PNG, JPG, JPEG, SVG, макс. 5MB)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        uploadMyCompanyLogo: async (logoFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logoFile' is not null or undefined
            assertParamExists('uploadMyCompanyLogo', 'logoFile', logoFile)
            const localVarPath = `/companies/my/branding/logo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (logoFile !== undefined) { 
                localVarFormParams.append('logoFile', logoFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandingApi - functional programming interface
 * @export
 */
export const BrandingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandingApiAxiosParamCreator(configuration)
    return {
        /**
         * Удаляет текущий логотип компании пользователя. Операция идемпотентна. После удаления система использует дефолтный логотип. 
         * @summary Удалить логотип компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMyCompanyLogo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMyCompanyLogo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandingApi.deleteMyCompanyLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить настройки брендинга
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBranding(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Branding>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBranding(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandingApi.getBranding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает брендинг компании пользователя. Если у компании нет собственного брендинга, возвращается fallback брендинг компании ID=1. 
         * @summary Получить брендинг своей компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyCompanyBranding(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Branding>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyCompanyBranding(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandingApi.getMyCompanyBranding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить настройки брендинга
         * @param {BrandingUpdateRequest} brandingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBranding(brandingUpdateRequest: BrandingUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Branding>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBranding(brandingUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandingApi.updateBranding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновляет или создает брендинг для компании пользователя. Если брендинг не существует, создается новый. 
         * @summary Обновить брендинг своей компании
         * @param {BrandingUpdateRequest} brandingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyCompanyBranding(brandingUpdateRequest: BrandingUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Branding>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyCompanyBranding(brandingUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandingApi.updateMyCompanyBranding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Загружает новый логотип для компании пользователя. Старый логотип удаляется с диска после успешного сохранения нового. 
         * @summary Загрузить логотип компании
         * @param {File} logoFile Файл логотипа (PNG, JPG, JPEG, SVG, макс. 5MB)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async uploadMyCompanyLogo(logoFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Branding>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMyCompanyLogo(logoFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BrandingApi.uploadMyCompanyLogo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BrandingApi - factory interface
 * @export
 */
export const BrandingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandingApiFp(configuration)
    return {
        /**
         * Удаляет текущий логотип компании пользователя. Операция идемпотентна. После удаления система использует дефолтный логотип. 
         * @summary Удалить логотип компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyCompanyLogo(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMyCompanyLogo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить настройки брендинга
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBranding(options?: RawAxiosRequestConfig): AxiosPromise<Branding> {
            return localVarFp.getBranding(options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает брендинг компании пользователя. Если у компании нет собственного брендинга, возвращается fallback брендинг компании ID=1. 
         * @summary Получить брендинг своей компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCompanyBranding(options?: RawAxiosRequestConfig): AxiosPromise<Branding> {
            return localVarFp.getMyCompanyBranding(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить настройки брендинга
         * @param {BrandingUpdateRequest} brandingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBranding(brandingUpdateRequest: BrandingUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Branding> {
            return localVarFp.updateBranding(brandingUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет или создает брендинг для компании пользователя. Если брендинг не существует, создается новый. 
         * @summary Обновить брендинг своей компании
         * @param {BrandingUpdateRequest} brandingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyCompanyBranding(brandingUpdateRequest: BrandingUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Branding> {
            return localVarFp.updateMyCompanyBranding(brandingUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Загружает новый логотип для компании пользователя. Старый логотип удаляется с диска после успешного сохранения нового. 
         * @summary Загрузить логотип компании
         * @param {File} logoFile Файл логотипа (PNG, JPG, JPEG, SVG, макс. 5MB)
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        uploadMyCompanyLogo(logoFile: File, options?: RawAxiosRequestConfig): AxiosPromise<Branding> {
            return localVarFp.uploadMyCompanyLogo(logoFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandingApi - object-oriented interface
 * @export
 * @class BrandingApi
 * @extends {BaseAPI}
 */
export class BrandingApi extends BaseAPI {
    /**
     * Удаляет текущий логотип компании пользователя. Операция идемпотентна. После удаления система использует дефолтный логотип. 
     * @summary Удалить логотип компании
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public deleteMyCompanyLogo(options?: RawAxiosRequestConfig) {
        return BrandingApiFp(this.configuration).deleteMyCompanyLogo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить настройки брендинга
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public getBranding(options?: RawAxiosRequestConfig) {
        return BrandingApiFp(this.configuration).getBranding(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает брендинг компании пользователя. Если у компании нет собственного брендинга, возвращается fallback брендинг компании ID=1. 
     * @summary Получить брендинг своей компании
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public getMyCompanyBranding(options?: RawAxiosRequestConfig) {
        return BrandingApiFp(this.configuration).getMyCompanyBranding(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить настройки брендинга
     * @param {BrandingUpdateRequest} brandingUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public updateBranding(brandingUpdateRequest: BrandingUpdateRequest, options?: RawAxiosRequestConfig) {
        return BrandingApiFp(this.configuration).updateBranding(brandingUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет или создает брендинг для компании пользователя. Если брендинг не существует, создается новый. 
     * @summary Обновить брендинг своей компании
     * @param {BrandingUpdateRequest} brandingUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public updateMyCompanyBranding(brandingUpdateRequest: BrandingUpdateRequest, options?: RawAxiosRequestConfig) {
        return BrandingApiFp(this.configuration).updateMyCompanyBranding(brandingUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Загружает новый логотип для компании пользователя. Старый логотип удаляется с диска после успешного сохранения нового. 
     * @summary Загрузить логотип компании
     * @param {File} logoFile Файл логотипа (PNG, JPG, JPEG, SVG, макс. 5MB)
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BrandingApi
     */
    public uploadMyCompanyLogo(logoFile: File, options?: RawAxiosRequestConfig) {
        return BrandingApiFp(this.configuration).uploadMyCompanyLogo(logoFile, options).then((request) => request(this.axios, this.basePath));
    }
}



